import { buildApiUrl } from '../config/apiConfig';
import type { BookingLanguageCode } from '../config/i18n';
import { getAuthToken } from './safeStorage';

/**
 * Persiste la langue UI booking sur users.preferred_language (emails carnet, etc.).
 * No-op si déconnecté ; erreurs ignorées pour ne pas bloquer le switch UI.
 */
export async function syncPreferredLanguageToBackend(
  language: BookingLanguageCode
): Promise<void> {
  const token = getAuthToken();
  if (!token) return;

  try {
    await fetch(buildApiUrl('/update-profile'), {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ preferredLanguage: language }),
    });
  } catch {
    /* ignore */
  }
}
